
// Inline styles converted from Social.module.css
export const styles = {
  socialShareContainer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 1%',
    zIndex: 2,
  },
  socialShareImg: {
    border: 'none',
    width: '80px',
    height: 'auto',
    objectFit: 'cover',
    borderRadius: '8px',
  },
  leftShareGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  rightShareGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  leftShareImg: {
    border: 'none',
    zIndex: 2,
    paddingLeft: 0,
    marginTop: '0%',
    position: 'fixed',
    left: '1%',
    bottom: 0,
    width: '8%',
    maxWidth: '80px',
    height: 'auto',
    borderRadius: '8px',
  },
  rightShareImg: {
    border: 'none',
    zIndex: 2,
    paddingRight: 0,
    marginTop: '0%',
    position: 'fixed',
    right: '1%',
    bottom: 0,
    width: '8%',
    maxWidth: '80px',
    height: 'auto',
    borderRadius: '8px',
  },
} as const;